export default __webpack_public_path__ + "static/media/zoomed_diagonalup_darktolight.e31fd2ef.png";